import React, { useContext, useState, useEffect } from 'react';
import { Modal, Button, Form, Dropdown } from 'react-bootstrap';
import { Context } from '../../index';
import { createSubType, fetchTypes } from '../../http/detailAPI';
import { observer } from 'mobx-react-lite';

const CreateSubType = observer(({ show, onHide }) => {
  const { detail } = useContext(Context);
  const [name, setName] = useState('');

  useEffect(() => {
    fetchTypes().then(data => detail.setTypes(data));
  }, []);

  const addSubType = () => {
    if (!detail.selectedType.id) {
      alert('Пожалуйста, выберите тип');
      return;
    }
    if (name.trim() === '') {
      alert('Пожалуйста, введите название подтипа');
      return;
    }

    createSubType({ name, typeId: detail.selectedType.id })
      .then(() => {
        alert('Подтип добавлен');
      })    
      .catch(error => {
        alert('Ошибка при добавлении подтипа: ' + error.message);
      });
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Добавить новый подтип
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Dropdown className="mt-2 mb-2">
            <Dropdown.Toggle>
              {detail.selectedType.name || 'Выберите тип'}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {detail.types.map(type => (
                <Dropdown.Item
                  onClick={() => detail.setSelectedType(type)}
                  key={type.id}
                >
                  {type.name}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <Form.Control
            value={name}
            onChange={e => setName(e.target.value)}
            placeholder="Введите название подтипа"
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-danger" onClick={onHide}>Закрыть</Button>
        <Button variant="outline-success" onClick={addSubType}>Добавить</Button>
      </Modal.Footer>
    </Modal>
  );
});

export default CreateSubType;